var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_772)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 1H39V31H-7V1Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 11H39V31H-7V11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 21H39V31H-7V21Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20C18.2582 20 20.0889 18.2091 20.0889 16C20.0889 13.7909 18.2582 12 16 12C13.7418 12 11.9111 13.7909 11.9111 16C11.9111 18.2091 13.7418 20 16 20Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5C17.9759 19.5 19.5778 17.933 19.5778 16C19.5778 14.067 17.9759 12.5 16 12.5C14.024 12.5 12.4222 14.067 12.4222 16C12.4222 17.933 14.024 19.5 16 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.7C16.3952 16.7 16.7155 16.3866 16.7155 16C16.7155 15.6134 16.3952 15.3 16 15.3C15.6048 15.3 15.2844 15.6134 15.2844 16C15.2844 16.3866 15.6048 16.7 16 16.7Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5171 16.6765C19.6405 16.6924 19.7538 16.6074 19.7701 16.4866C19.7863 16.3658 19.6994 16.255 19.5759 16.2391C19.4525 16.2232 19.3392 16.3082 19.3229 16.429C19.3067 16.5498 19.3936 16.6606 19.5171 16.6765Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 19.501L16.122 17.401L15.9993 16.401L15.8767 17.401L15.9993 19.501Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2181 17.5443C19.3327 17.5905 19.4646 17.5363 19.5127 17.4233C19.5608 17.3103 19.5069 17.1813 19.3923 17.1351C19.2777 17.089 19.1458 17.1431 19.0977 17.2561C19.0496 17.3691 19.1035 17.4981 19.2181 17.5443Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.072 19.3817L15.7467 17.3829L15.8957 16.3861L15.5132 17.3219L15.072 19.3817Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 18.3066C18.7986 18.3802 18.9401 18.3613 19.0164 18.2641C19.0927 18.167 19.0748 18.0285 18.9765 17.9549C18.8782 17.8812 18.7367 17.9001 18.6604 17.9973C18.5841 18.0944 18.6019 18.2329 18.7002 18.3066Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2099 19.0318L15.3899 17.2715L15.7967 16.3457L15.1797 17.1529L14.2099 19.0318Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9983 18.9118C18.0737 19.008 18.2152 19.0256 18.3145 18.951C18.4137 18.8764 18.433 18.738 18.3576 18.6417C18.2822 18.5455 18.1407 18.5279 18.0415 18.6025C17.9422 18.6771 17.9229 18.8156 17.9983 18.9118Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4693 18.4756L15.0742 17.0738L15.7116 16.2821L14.9023 16.9056L13.4693 18.4756Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1617 19.3171C17.2099 19.4301 17.3418 19.4844 17.4564 19.4383C17.5709 19.3922 17.6247 19.2632 17.5765 19.1501C17.5283 19.037 17.3964 18.9828 17.2819 19.0289C17.1673 19.075 17.1136 19.204 17.1617 19.3171Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9023 17.7488L14.8224 16.8055L15.6451 16.2012L14.6982 16.5953L12.9023 17.7488Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2443 19.4979C16.2611 19.6192 16.3744 19.7051 16.4973 19.6897C16.6203 19.6743 16.7063 19.5635 16.6895 19.4422C16.6728 19.3209 16.5595 19.2351 16.4365 19.2505C16.3136 19.2658 16.2275 19.3766 16.2443 19.4979Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5447 16.9041L14.6497 16.4806L15.6044 16.1052L14.585 16.2453L12.5447 16.9041Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3085 19.4403C15.2928 19.5606 15.3805 19.6714 15.5045 19.6878C15.6285 19.7042 15.7418 19.62 15.7575 19.4998C15.7733 19.3795 15.6855 19.2687 15.5615 19.2523C15.4375 19.2359 15.3242 19.3201 15.3085 19.4403Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4228 15.9931L14.5693 16.1155L15.5905 16.0069L14.5681 15.8893L12.4228 15.9931Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 19.1488C14.3747 19.2611 14.4297 19.3902 14.545 19.437C14.6603 19.4838 14.7922 19.4307 14.8396 19.3184C14.887 19.2061 14.832 19.077 14.7167 19.0302C14.6014 18.9833 14.4695 19.0365 14.4221 19.1488Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5438 15.0933L14.5863 15.7531L15.6053 15.8973L14.6492 15.5229L12.5438 15.0933Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.644 18.6433C13.5677 18.7404 13.5855 18.8789 13.6838 18.9526C13.7821 19.0262 13.9237 19.0072 14 18.9101C14.0763 18.813 14.0585 18.6745 13.9601 18.6008C13.8618 18.5271 13.7203 18.5461 13.644 18.6433Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9023 14.2511L14.6983 15.4047L15.6451 15.7988L14.8224 15.1945L12.9023 14.2511Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0252 17.9565C12.9259 18.0311 12.9064 18.1696 12.9818 18.2658C13.0571 18.3619 13.1986 18.3794 13.2979 18.3048C13.3972 18.2301 13.4166 18.0916 13.3413 17.9955C13.266 17.8993 13.1244 17.8818 13.0252 17.9565Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.471 13.526L14.9001 15.0954L15.71 15.7163L15.0753 14.924L13.471 13.526Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.609 17.1362C12.4935 17.1832 12.4383 17.3122 12.4856 17.4244C12.5329 17.5366 12.6648 17.5895 12.7802 17.5425C12.8956 17.4955 12.9509 17.3665 12.9036 17.2543C12.8563 17.1421 12.7244 17.0892 12.609 17.1362Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.212 12.9694L15.1771 14.8479L15.7947 15.653L15.3912 14.7268L14.212 12.9694Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4241 16.2388C12.3002 16.255 12.2127 16.3658 12.2286 16.4863C12.2445 16.6067 12.3577 16.6911 12.4816 16.6749C12.6054 16.6586 12.6929 16.5478 12.6771 16.4274C12.6612 16.307 12.5479 16.2225 12.4241 16.2388Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0752 12.6197L15.5094 14.679L15.8929 15.6132L15.7489 14.6161L15.0752 12.6197Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4833 15.3235C12.3603 15.3081 12.2471 15.3939 12.2303 15.5152C12.2135 15.6365 12.2995 15.7473 12.4224 15.7627C12.5454 15.7781 12.6586 15.6923 12.6754 15.571C12.6922 15.4497 12.6062 15.3389 12.4833 15.3235Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0073 12.5006L15.882 14.6004L15.9928 15.5994L16.1129 14.5992L16.0073 12.5006Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7817 14.456C12.6671 14.4098 12.5352 14.464 12.4871 14.577C12.439 14.6899 12.4929 14.819 12.6075 14.8652C12.7221 14.9114 12.854 14.8572 12.9021 14.7442C12.9502 14.6312 12.8963 14.5022 12.7817 14.456Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9278 12.6187L16.2531 14.6174L16.1041 15.6142L16.4865 14.6784L16.9278 12.6187Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2997 13.6934C13.2014 13.6197 13.0599 13.6387 12.9836 13.7359C12.9073 13.833 12.9251 13.9715 13.0234 14.0452C13.1217 14.1188 13.2633 14.0999 13.3396 14.0027C13.4159 13.9056 13.398 13.7671 13.2997 13.6934Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7901 12.9682L16.6101 14.7285L16.2033 15.6543L16.8202 14.8471L17.7901 12.9682Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0018 13.0881C13.9264 12.9919 13.7849 12.9744 13.6856 13.0491C13.5863 13.1237 13.5669 13.2622 13.6422 13.3584C13.7176 13.4546 13.8591 13.472 13.9584 13.3974C14.0577 13.3228 14.0771 13.1843 14.0018 13.0881Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5308 13.5243L16.9258 14.9263L16.2883 15.718L17.0975 15.0944L18.5308 13.5243Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8382 12.683C14.79 12.5699 14.6581 12.5156 14.5436 12.5618C14.4291 12.6079 14.3753 12.7369 14.4235 12.85C14.4717 12.963 14.6036 13.0173 14.7181 12.9712C14.8326 12.9251 14.8864 12.7961 14.8382 12.683Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0977 14.2512L17.1776 15.1945L16.3549 15.7988L17.3017 15.4047L19.0977 14.2512Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7556 12.5021C15.7389 12.3808 15.6256 12.295 15.5027 12.3103C15.3797 12.3257 15.2936 12.4365 15.3104 12.5578C15.3272 12.6791 15.4405 12.765 15.5634 12.7496C15.6864 12.7342 15.7724 12.6234 15.7556 12.5021Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4553 15.0959L17.3502 15.5195L16.3956 15.8948L17.4149 15.7547L19.4553 15.0959Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6916 12.5598C16.7073 12.4396 16.6194 12.3288 16.4953 12.3123C16.3712 12.2958 16.258 12.3799 16.2423 12.5001C16.2267 12.6203 16.3146 12.7311 16.4386 12.7476C16.5627 12.7641 16.676 12.68 16.6916 12.5598Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 16.0078L17.4307 15.885L16.4095 15.9923L17.432 16.1095L19.5771 16.0078Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.578 12.8514C17.6254 12.7392 17.5702 12.6102 17.4548 12.5632C17.3395 12.5163 17.2076 12.5693 17.1602 12.6815C17.1129 12.7938 17.168 12.9228 17.2834 12.9697C17.3988 13.0167 17.5307 12.9637 17.578 12.8514Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4563 16.9071L17.4135 16.2472L16.3945 16.1024L17.3508 16.4767L19.4563 16.9071Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3573 13.358C18.4329 13.2616 18.4138 13.1231 18.3148 13.0487C18.2157 12.9743 18.0742 12.9922 17.9986 13.0886C17.9231 13.185 17.9421 13.3235 18.0411 13.3979C18.1402 13.4723 18.2817 13.4545 18.3573 13.358Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0988 17.7506L17.3002 16.5965L16.3537 16.1994L17.1782 16.8032L19.0988 17.7506Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9761 14.0448C19.0747 13.9709 19.0929 13.8324 19.0169 13.7356C18.9408 13.6387 18.7992 13.62 18.7007 13.694C18.6021 13.7679 18.5839 13.9064 18.66 14.0033C18.736 14.1001 18.8776 14.1188 18.9761 14.0448Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5303 18.4754L17.0981 16.9054L16.2887 16.2825L16.9255 17.0743L18.5303 18.4754Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3921 14.8648C19.507 14.8184 19.5612 14.6894 19.5133 14.5766C19.4654 14.4638 19.3335 14.41 19.2187 14.4564C19.1039 14.5028 19.0496 14.6318 19.0975 14.7446C19.1454 14.8574 19.2773 14.9112 19.3921 14.8648Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7894 19.0314L16.821 17.1526L16.2039 16.3461L16.6097 17.272L17.7894 19.0314Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.577 15.7623C19.7003 15.7467 19.7868 15.6359 19.7703 15.5148C19.7538 15.3938 19.6405 15.3084 19.5173 15.3241C19.3941 15.3398 19.3075 15.4506 19.324 15.5716C19.3405 15.6926 19.4538 15.778 19.577 15.7623Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9268 19.381L16.4878 17.3214L16.105 16.3861L16.2524 17.383L16.9268 19.381Z",
    fill: "#000088"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D7D7D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIn);
export default __webpack_public_path__ + "static/media/country-in.71154e04.svg";
export { ForwardRef as ReactComponent };